// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file common/common_model.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenEnum, GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { enumDesc, fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

/**
 * Describes the file common/common_model.proto.
 */
export const file_common_common_model: GenFile =
  /*@__PURE__*/
  fileDesc(
    'Chljb21tb24vY29tbW9uX21vZGVsLnByb3RvEhRjb20uZ2VtLmJmZi5jb250cmFjdCJlCgxEZWVwTGlua0luZm8SEAoIZGVlcExpbmsYASABKAkSFQoNZGVlcExpbmtBbGlhcxgCIAEoCRIaCg1kZWVwTGlua1FyVXJsGAMgASgJSACIAQFCEAoOX2RlZXBMaW5rUXJVcmwi1AEKC0xpbmtQcmV2aWV3EhMKC2Rlc2NyaXB0aW9uGAEgASgJEg4KBmRvbWFpbhgCIAEoCRIMCgRsaW5rGAMgASgJEg0KBXRpdGxlGAQgASgJEjYKBWltYWdlGAUgASgLMiIuY29tLmdlbS5iZmYuY29udHJhY3QuSW1hZ2VQcmV2aWV3SACIAQESNwoFdmlkZW8YBiABKAsyIy5jb20uZ2VtLmJmZi5jb250cmFjdC5FeHRlcm5hbFZpZGVvSAGIAQFCCAoGX2ltYWdlQggKBl92aWRlbyJTCgxJbWFnZVByZXZpZXcSNgoLZ3JhcGhpY1NpemUYASABKAsyIS5jb20uZ2VtLmJmZi5jb250cmFjdC5HcmFwaGljU2l6ZRILCgN1cmwYAiABKAkiLAoLR3JhcGhpY1NpemUSDgoGaGVpZ2h0GAEgASgFEg0KBXdpZHRoGAIgASgFIpUBCg1FeHRlcm5hbFZpZGVvEj0KB3lvdVR1YmUYASABKAsyKi5jb20uZ2VtLmJmZi5jb250cmFjdC5FeHRlcm5hbFlvdVR1YmVWaWRlb0gAEj0KB3Vua25vd24YAiABKAsyKi5jb20uZ2VtLmJmZi5jb250cmFjdC5FeHRlcm5hbFVua25vd25WaWRlb0gAQgYKBHR5cGUiOQoURXh0ZXJuYWxZb3VUdWJlVmlkZW8SDwoHdmlkZW9JZBgBIAEoCRIQCgh0aW1lQ29kZRgCIAEoAyIWChRFeHRlcm5hbFVua25vd25WaWRlbyI/ChFSZWFjdGlvbkNvdW50RGF0YRISCgpyZWFjdGlvbklkGAEgASgDEhYKDnJlYWN0aW9uc0NvdW50GAIgASgDIjUKBVJhbmdlEhYKDnN0YXJ0SW5jbHVzaXZlGAEgASgFEhQKDGVuZEV4Y2x1c2l2ZRgCIAEoBSo1CghQbGF0Zm9ybRIHCgNXRUIQABILCgdBTkRST0lEEAESBwoDSU9TEAISCgoGSFVBV0VJEAMqSgoQQ2FsbEZpbmlzaFJlYXNvbhISCg5DRlJfVU5BTlNXRVJFRBAAEhAKDENGUl9ERUNMSU5FRBABEhAKDENGUl9GSU5JU0hFRBACKi0KC1N0aWNrZXJUeXBlEg8KC1NUX0FOSU1BVEVEEAASDQoJU1RfU1RBVElDEAFCGAoUY29tLmdlbS5iZmYuY29udHJhY3RQAWIGcHJvdG8z'
  );

/**
 * @generated from message com.gem.bff.contract.DeepLinkInfo
 */
export type DeepLinkInfo = Message<'com.gem.bff.contract.DeepLinkInfo'> & {
  /**
   * @generated from field: string deepLink = 1;
   */
  deepLink: string;

  /**
   * @generated from field: string deepLinkAlias = 2;
   */
  deepLinkAlias: string;

  /**
   * @generated from field: optional string deepLinkQrUrl = 3;
   */
  deepLinkQrUrl?: string;
};

/**
 * Describes the message com.gem.bff.contract.DeepLinkInfo.
 * Use `create(DeepLinkInfoSchema)` to create a new message.
 */
export const DeepLinkInfoSchema: GenMessage<DeepLinkInfo> =
  /*@__PURE__*/
  messageDesc(file_common_common_model, 0);

/**
 * @generated from message com.gem.bff.contract.LinkPreview
 */
export type LinkPreview = Message<'com.gem.bff.contract.LinkPreview'> & {
  /**
   * @generated from field: string description = 1;
   */
  description: string;

  /**
   * @generated from field: string domain = 2;
   */
  domain: string;

  /**
   * @generated from field: string link = 3;
   */
  link: string;

  /**
   * @generated from field: string title = 4;
   */
  title: string;

  /**
   * @generated from field: optional com.gem.bff.contract.ImagePreview image = 5;
   */
  image?: ImagePreview;

  /**
   * @generated from field: optional com.gem.bff.contract.ExternalVideo video = 6;
   */
  video?: ExternalVideo;
};

/**
 * Describes the message com.gem.bff.contract.LinkPreview.
 * Use `create(LinkPreviewSchema)` to create a new message.
 */
export const LinkPreviewSchema: GenMessage<LinkPreview> =
  /*@__PURE__*/
  messageDesc(file_common_common_model, 1);

/**
 * @generated from message com.gem.bff.contract.ImagePreview
 */
export type ImagePreview = Message<'com.gem.bff.contract.ImagePreview'> & {
  /**
   * @generated from field: com.gem.bff.contract.GraphicSize graphicSize = 1;
   */
  graphicSize?: GraphicSize;

  /**
   * @generated from field: string url = 2;
   */
  url: string;
};

/**
 * Describes the message com.gem.bff.contract.ImagePreview.
 * Use `create(ImagePreviewSchema)` to create a new message.
 */
export const ImagePreviewSchema: GenMessage<ImagePreview> =
  /*@__PURE__*/
  messageDesc(file_common_common_model, 2);

/**
 * @generated from message com.gem.bff.contract.GraphicSize
 */
export type GraphicSize = Message<'com.gem.bff.contract.GraphicSize'> & {
  /**
   * @generated from field: int32 height = 1;
   */
  height: number;

  /**
   * @generated from field: int32 width = 2;
   */
  width: number;
};

/**
 * Describes the message com.gem.bff.contract.GraphicSize.
 * Use `create(GraphicSizeSchema)` to create a new message.
 */
export const GraphicSizeSchema: GenMessage<GraphicSize> =
  /*@__PURE__*/
  messageDesc(file_common_common_model, 3);

/**
 * @generated from message com.gem.bff.contract.ExternalVideo
 */
export type ExternalVideo = Message<'com.gem.bff.contract.ExternalVideo'> & {
  /**
   * @generated from oneof com.gem.bff.contract.ExternalVideo.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.ExternalYouTubeVideo youTube = 1;
         */
        value: ExternalYouTubeVideo;
        case: 'youTube';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ExternalUnknownVideo unknown = 2;
         */
        value: ExternalUnknownVideo;
        case: 'unknown';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.ExternalVideo.
 * Use `create(ExternalVideoSchema)` to create a new message.
 */
export const ExternalVideoSchema: GenMessage<ExternalVideo> =
  /*@__PURE__*/
  messageDesc(file_common_common_model, 4);

/**
 * @generated from message com.gem.bff.contract.ExternalYouTubeVideo
 */
export type ExternalYouTubeVideo = Message<'com.gem.bff.contract.ExternalYouTubeVideo'> & {
  /**
   * @generated from field: string videoId = 1;
   */
  videoId: string;

  /**
   * @generated from field: int64 timeCode = 2;
   */
  timeCode: bigint;
};

/**
 * Describes the message com.gem.bff.contract.ExternalYouTubeVideo.
 * Use `create(ExternalYouTubeVideoSchema)` to create a new message.
 */
export const ExternalYouTubeVideoSchema: GenMessage<ExternalYouTubeVideo> =
  /*@__PURE__*/
  messageDesc(file_common_common_model, 5);

/**
 * @generated from message com.gem.bff.contract.ExternalUnknownVideo
 */
export type ExternalUnknownVideo = Message<'com.gem.bff.contract.ExternalUnknownVideo'> & {};

/**
 * Describes the message com.gem.bff.contract.ExternalUnknownVideo.
 * Use `create(ExternalUnknownVideoSchema)` to create a new message.
 */
export const ExternalUnknownVideoSchema: GenMessage<ExternalUnknownVideo> =
  /*@__PURE__*/
  messageDesc(file_common_common_model, 6);

/**
 * @generated from message com.gem.bff.contract.ReactionCountData
 */
export type ReactionCountData = Message<'com.gem.bff.contract.ReactionCountData'> & {
  /**
   * @generated from field: int64 reactionId = 1;
   */
  reactionId: bigint;

  /**
   * @generated from field: int64 reactionsCount = 2;
   */
  reactionsCount: bigint;
};

/**
 * Describes the message com.gem.bff.contract.ReactionCountData.
 * Use `create(ReactionCountDataSchema)` to create a new message.
 */
export const ReactionCountDataSchema: GenMessage<ReactionCountData> =
  /*@__PURE__*/
  messageDesc(file_common_common_model, 7);

/**
 * @generated from message com.gem.bff.contract.Range
 */
export type Range = Message<'com.gem.bff.contract.Range'> & {
  /**
   * @generated from field: int32 startInclusive = 1;
   */
  startInclusive: number;

  /**
   * @generated from field: int32 endExclusive = 2;
   */
  endExclusive: number;
};

/**
 * Describes the message com.gem.bff.contract.Range.
 * Use `create(RangeSchema)` to create a new message.
 */
export const RangeSchema: GenMessage<Range> =
  /*@__PURE__*/
  messageDesc(file_common_common_model, 8);

/**
 * @generated from enum com.gem.bff.contract.Platform
 */
export enum Platform {
  /**
   * @generated from enum value: WEB = 0;
   */
  WEB = 0,

  /**
   * @generated from enum value: ANDROID = 1;
   */
  ANDROID = 1,

  /**
   * @generated from enum value: IOS = 2;
   */
  IOS = 2,

  /**
   * @generated from enum value: HUAWEI = 3;
   */
  HUAWEI = 3,
}

/**
 * Describes the enum com.gem.bff.contract.Platform.
 */
export const PlatformSchema: GenEnum<Platform> =
  /*@__PURE__*/
  enumDesc(file_common_common_model, 0);

/**
 * @generated from enum com.gem.bff.contract.CallFinishReason
 */
export enum CallFinishReason {
  /**
   * @generated from enum value: CFR_UNANSWERED = 0;
   */
  CFR_UNANSWERED = 0,

  /**
   * @generated from enum value: CFR_DECLINED = 1;
   */
  CFR_DECLINED = 1,

  /**
   * @generated from enum value: CFR_FINISHED = 2;
   */
  CFR_FINISHED = 2,
}

/**
 * Describes the enum com.gem.bff.contract.CallFinishReason.
 */
export const CallFinishReasonSchema: GenEnum<CallFinishReason> =
  /*@__PURE__*/
  enumDesc(file_common_common_model, 1);

/**
 * @generated from enum com.gem.bff.contract.StickerType
 */
export enum StickerType {
  /**
   * @generated from enum value: ST_ANIMATED = 0;
   */
  ST_ANIMATED = 0,

  /**
   * @generated from enum value: ST_STATIC = 1;
   */
  ST_STATIC = 1,
}

/**
 * Describes the enum com.gem.bff.contract.StickerType.
 */
export const StickerTypeSchema: GenEnum<StickerType> =
  /*@__PURE__*/
  enumDesc(file_common_common_model, 2);
